import axios from "axios";
import React, { useEffect, useRef } from "react";
import { apiKey } from "../../config/config";
import { toast } from "react-toastify";
import { RxCross1 } from "react-icons/rx";
import MessageCard from "./MessageCard";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
// import { useNavigate } from "react-router-dom";

function ShiftModal({ toggle, data, error, logo, general, currency }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const navigate = useNavigate();
  const componentRef = useRef(null);

  const handleCloseShift = () => {
    axios
      .post(
        `${apiKey}/api/rms/admin/shift/close`,
        {
          closing_balance: data.shift.closing_balance,
          sale_paid_amount: data.total.total_sale_amount,
          total_vat_amount: data.total.total_vat_sum,
          total_items: data.total.total_items,
          sub_total_amount: data.total.sub_total,
          total_discount: data.total.total_discount_amount,
          menudetails: JSON.stringify(data.sold_items),
          total_delivery_charge: data.total.total_delivery_charges,
          multiple_payments: JSON.stringify(data.multi_payment_totals),
          payment_methods_sale: JSON.stringify(data.payments),
          // total_expense: data.total.total_discount_amount,
          outlet_id: user?.user?.outlet_id,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        handlePrint();
        toggle();
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Invoice",
  });

  useEffect(() => {
    // Add the 'body-no-scroll' class to the body when the modal is open
    document.body.classList.add("overflow-y-hidden");

    // Remove the 'overflow-y-hidden' class when the modal is closed
    return () => {
      document.body.classList.remove("overflow-y-hidden");
    };
  }, [error]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/verifyShift`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {})
      .catch((err) => {
        if (error) {
          navigate("openRegister");
          toggle();
        }
      });
  }, [error, navigate, toggle, user?.token]);

  if (error) {
    // navigate("")
    return (
      <div
        className="grid place-items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-[100] bg-black bg-opacity-20 fade-in"
        onClick={() => toggle()}
      >
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          <div
            className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white shiftmodel fade-in-down p-2"
            onClick={(e) => e.stopPropagation()}
          >
            <MessageCard error={error} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="grid place-items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-[100] bg-black bg-opacity-20 fade-in"
      onClick={() => toggle()}
    >
      <div className="relative w-auto my-6 mx-auto max-w-3xl">
        {/*content*/}
        <div
          className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white shiftmodel fade-in-down"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="text-black absolute top-4 right-4 z-10"
            onClick={() => toggle()}
          >
            <span className="bg-transparent text-black block">
              <RxCross1 />
            </span>
          </button>
          {/*header*/}
          {/*body*/}
          <div className="relative p-6 text-center" ref={componentRef}>
            <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
              {/* <h3 className="text-3xl font-semibold">Modal Title</h3> */}
              <img
                src={logo.logo_image_url || ""}
                className="w-24 mx-auto"
                alt=""
              />
            </div>
            <p className="text-yellow-300 text-lg leading-relaxed">
              ({data.shift.opening_balance_date_time} to Not Closed Yet)
              Register Details
            </p>
            <p className="text-center p-3 text-2xl">
              Name/الإسم: {general.restaurant_name}
            </p>
            <p className="text-center bg-teal-600 text-white text-2xl p-2">
              Cashier/الكاشير
            </p>
            <p className="p-2">Cashier/الكاشير: {user?.user.name}</p>
            <p className="p-2">Contact No/رقم التواصل‎: {general.phone}</p>
            <p className="p-2">VAT No/الرقم الضريبي‎: {general.tax_reg_no}</p>

            <p className="text-center text-2xl bg-emerald-700 text-white p-2">
              Opening Balance/الرصيد الإفتتاحي
            </p>
            <p className="p-2">
              Opening Balance/الرصيد الإفتتاحي: {currency.value}{" "}
              {data.shift.opening_balance}
            </p>

            <p className="text-center text-2xl bg-rose-600 text-white p-2">
              Closing Balance/الرصيد الختامي
            </p>
            <p className="p-2">
              Closing Balance/الرصيد الختامي: {currency.value}{" "}
              {data.shift.closing_balance}
            </p>

            <p className="text-center text-2xl bg-fuchsia-700	text-white p-2">
              Total Sales Amount/مجموع المبيعات
            </p>
            <p className="p-2">
              Total Sale Amount/مجموع المبيعات: {currency.value}{" "}
              {data.total.total_sale_amount}
            </p>

            <p className="text-center text-2xl bg-orange-600 text-white p-2">
              Sub Total/مجموع الضريبة
            </p>
            <p className="p-2">
              Sub Total/المجموع الفرعي: {currency.value} {data.total.sub_total}
            </p>

            <p className="text-center text-2xl bg-amber-500	text-white p-2 ">
              Total Vat/مجموع ضريبة القيمة المضافة
            </p>
            <p className="p-2">
              Total Vat/مجموع ضريبة القيمة المضافة: {currency.value}{" "}
              {data.total.total_vat_sum}
            </p>

            <p className="text-center text-2xl bg-sky-500	text-white p-2">
              Total Discount/مجموع الخصم
            </p>
            <p className="p-2">
              Total Discount/مجموع الخصم: {currency.value}{" "}
              {data.total.total_discount_amount}
            </p>

            <p className="text-center text-2xl bg-pink-500 text-white p-2">
              Total Delivery Charges/إجمالي رسوم التوصيل
            </p>
            <p className="p-2">
              Total Delivery Charges/إجمالي رسوم التوصيل: {currency.value}{" "}
              {data.total.total_delivery_charges}
            </p>

            <p className="text-center text-2xl bg-amber-800	text-white p-2 ">
              Total Return/عودة كاملة
            </p>
            <p className="p-2">
              Total Return/عودة كاملة: {currency.value}{" "}
              {data.shift.opening_balance}
            </p>

            <p className="text-center text-2xl bg-fuchsia-700	text-white p-2 ">
              Total Expense/المصاريف الكلية
            </p>
            <p className="p-2">
              Total Expense/المصاريف الكلية: {currency.value}{" "}
              {data.shift.opening_balance}
            </p>

            <p className="text-center text-2xl bg-red-500	text-white p-2">
              Total Sales Item/مجموع أصناف المبيعات
            </p>
            <p className="p-2">
              Total Sales Items/مجموع أصناف المبيعات‎:({data.total.total_items})
            </p>

            <p className="text-center text-2xl bg-pink-600 text-white p-2">
              Payment Types/طرق الدفع
            </p>
            {/* <p className="p-2">Paid by wallet/تدفع عن طريق المحفظة: {currency.value} {data.shift.opening_balance}</p> */}

            <p className="p-2">
              Cash/النقد: {currency.value}{" "}
              {data.payments?.find((pay) => pay.payment?.name === "Cash")
                ?.total_paid_sum || 0}
            </p>
            <p className="p-2">
              Mada/مدى: {currency.value}{" "}
              {data.payments?.find((pay) => pay.payment?.name === "Mada")
                ?.total_paid_sum || 0}
            </p>
            <p className="p-2">
              Visa/فيزا: {currency.value}{" "}
              {data.payments?.find((pay) => pay.payment?.name === "Visa")
                ?.total_paid_sum || 0}
            </p>
            <p className="p-2">
              Master Card/ماستركارد: {currency.value}{" "}
              {data.payments?.find((pay) => pay.payment?.name === "Master Card")
                ?.total_paid_sum || 0}
            </p>
            <p className="p-2">
              Number Of Multiple Payments/عدد عمليات الدفع المتعددة‎:(
              {data.multi_payment_totals.length})
            </p>

            <p className="text-center text-2xl bg-gray-400 text-white p-2 ">
              Type Of Multiple Payments/نوع المدفوعات المتعددة
            </p>
            {data.multi_payment_totals.map((pay, index) => (
              <p key={index} className="p-2">
                {`${pay.payment_name}: ${currency.value} ${pay.total_payment_sum}`}
              </p>
            ))}

            <br />
            <p className="text-center text-2xl bg-rose-600 text-white p-2 ">
              Delivery Companies Payment/دفع شركات التوصيل
            </p>
            <br />
            <p className="text-center text-2xl bg-sky-800	text-white p-2 ">
              Quantity of items/عدد الأصناف
            </p>
            {data.sold_items.map((item, index) => (
              <span className="pt-3 flex gap-2 justify-center" key={index}>
                <span>
                  {item.item_name} / {item.item_name_ar}:{" "}
                </span>
                <span> ({item.total_quantity})</span>
              </span>
            ))}
          </div>
          {/*footer*/}
          <div className="flex items-center justify-center p-6 border-t border-solid border-blueGray-200 rounded-b">
            <button
              className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              type="submit"
              onClick={() => toggle()}
            >
              Back/رجوع
            </button>
            <button
              className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              type="submit"
            >
              Print/طباعة
            </button>
            <button
              className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              type="submit"
              onClick={() => handleCloseShift()}
            >
              Print & Close/طباعة وإغلاق{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShiftModal;
